import { useEffect } from "react";
import { useParams, Link } from "react-router-dom";
import { Seo } from "../../components/Seo";
import { useGym } from "../../api/hooks";
import { api } from "../../api/client";
import { GymTabs } from "../../components/GymTabs";
import { track } from "../../lib/track";

export function Reservation() {
  const { gym = "brest" } = useParams();
  const { data } = useGym(gym);

  useEffect(() => {
    if (!data) return;
    api("/analytics/event", {
      method: "POST",
      json: { type: "reservation_click", gym, path: `/reservation/${gym}` },
    }).catch(() => {});
  }, [data, gym]);

  return (
    <>
      <Seo
        title={`Réservation ${data?.name ?? ""}`}
        description={`Réservez votre cours de CrossFit à ${data?.name}.`}
        path={`/reservation/${gym}`}
      />

      <section className="bg-paper py-10 text-ink-900">
        <div className="container">
          <span className="eyebrow">Réservation</span>
          <h1 className="h-hero mt-2">{data?.name}</h1>
          <GymTabs basePath="/reservation" className="mt-6" />
        </div>
      </section>

      <section className="section">
        <div className="container-narrow">
          {/* Drop-in & séance d'essai : ces demandes passent par le formulaire de contact,
              pas par la plateforme de réservation des cours. */}
          <div className="rounded-lg border border-brand-200 bg-brand-50 p-5">
            <h2 className="font-display text-lg font-bold uppercase">
              Drop-in ou séance d'essai gratuite ?
            </h2>
            <p className="mt-2 text-sm text-ink-700">
              Cette page permet de réserver un cours si vous êtes déjà adhérent. Pour une{" "}
              <strong>séance d'essai offerte</strong> ou un <strong>drop-in</strong> (visiteur de
              passage), écrivez-nous via le formulaire de contact : on vous recontacte pour
              organiser votre venue.
            </p>
            <div className="mt-4 flex flex-col gap-3 sm:flex-row">
              <Link to={`/contact?gym=${gym}&type=trial`} className="btn-primary w-full sm:w-auto">
                Réserver ma séance d'essai offerte
              </Link>
              <Link
                to={`/contact?gym=${gym}&type=dropin`}
                className="btn-outline w-full sm:w-auto"
              >
                Demander un drop-in
              </Link>
            </div>
          </div>

          {data?.reservationEmbedHtml ? (
            <div
              className="mt-8 overflow-hidden rounded-lg border border-ink-300"
              dangerouslySetInnerHTML={{ __html: data.reservationEmbedHtml }}
            />
          ) : (
            <div className="card mt-8 text-center">
              <h2 className="font-display text-2xl font-bold uppercase">Accéder à la réservation</h2>
              <p className="mt-3 text-ink-500">
                La réservation est gérée via notre plateforme partenaire.
              </p>
              {data?.reservationUrl && (
                <a
                  href={data.reservationUrl}
                  target="_blank"
                  rel="noopener noreferrer"
                  onClick={() => track({ type: "reservation_open", gym })}
                  className="btn-primary mt-6"
                >
                  Ouvrir la plateforme de réservation
                </a>
              )}
            </div>
          )}
        </div>
      </section>
    </>
  );
}
